/**
 * Service layer — Client Hub billing (public, token is the only credential).
 * Routes through api/journey-billing.js. Components never call the endpoint directly.
 */

/** The project's posted invoices (status only — no amounts) + which are still unacknowledged.
 *  Returns { invoices: [{ coreId, number, date, paid, payUrl, acknowledged }], pending: [coreId,...] }.
 *  ONE pay link per invoice — our own checkout page (/pay?t=...), where the client picks bank
 *  transfer, card, Zelle or wire. No surcharge: the firm absorbs the processing cost on every rail
 *  (dropped 2026-09-13) — see docs/STRIPE_PAYMENTS.md. */
// The journey's PIN proof travels with every client-facing call: as of 2026-09-12 these routes
// require it, because a PIN is what ties a visit to a named person. The proof is minted when the
// client enters their PIN and cached for 30 days, so this is already present by the time any of
// this renders.
import { getCachedPinProof, isPreviewToken } from './journey.js'

export async function getJourneyBilling(token) {
  const r = await fetch('/api/journey-billing?t=' + encodeURIComponent(token) +
    '&pinProof=' + encodeURIComponent(getCachedPinProof(token) || ''))
  if (r.status === 404) { const e = new Error('not_found'); e.code = 'not_found'; throw e }
  if (!r.ok) throw new Error('Client Hub billing request failed: ' + r.status)
  return r.json()
}

/** Acknowledge a newly-posted invoice (clears the popup, files it into the drawer, pings the firm). */
export async function acknowledgeInvoice(token, invoiceCoreId) {
  if (isPreviewToken(token)) return { ok: true, preview: true }   // preview: not recorded, firm not pinged
  const r = await fetch('/api/journey-billing', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ t: token, action: 'acknowledge', invoiceCoreId, pinProof: getCachedPinProof(token) }),
  })
  if (!r.ok) throw new Error('Acknowledge failed: ' + r.status)
  return r.json()
}
